import { cn } from '@/lib/utils';

interface QuickFilter {
  value: string;
  label: string;
  color: string;
}

interface QuickFiltersProps {
  filters: QuickFilter[];
  activeFilter: string;
  onToggle: (value: string) => void;
}

export default function QuickFilters({
  filters,
  activeFilter,
  onToggle,
}: QuickFiltersProps) {
  return (
    <>
      {filters.map(filter => {
        const isActive = activeFilter === filter.value;
        return (
          <button
            key={filter.value}
            type="button"
            onClick={() => onToggle(filter.value)}
            className={cn(
              'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-sm font-medium transition-colors',
              isActive
                ? 'text-white border-transparent'
                : 'bg-white text-gray-600 border-gray-300 hover:border-gray-400'
            )}
            style={isActive ? { backgroundColor: filter.color, borderColor: filter.color } : {}}
          >
            <div
              className="w-1.5 h-1.5 rounded-full"
              style={{ backgroundColor: isActive ? 'white' : filter.color }}
            />
            {filter.label}
          </button>
        );
      })}
    </>
  );
}
